import React from 'react'
import { Button, Dropdown } from 'antd'
import { TranslationOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'

const LanguageSwitcher = ({ style = {} }) => {
  const { i18n } = useTranslation()
  const languages = [
    { code: 'en', label: 'English' },
    { code: 'fr', label: 'Français' },
  ]

  const menuProps = {
    items: languages.map(lang => ({
      key: lang.code,
      label: lang.label,
    })),
    selectedKeys: [i18n.language],
    onClick: ({ key }) => i18n.changeLanguage(key),
  }

  return (
    <Dropdown menu={menuProps} trigger={['click']}>
      <Button icon={<TranslationOutlined />} style={style}>
        {languages.find(l => l.code === i18n.language)?.label}
      </Button>
    </Dropdown>
  )
}

export default LanguageSwitcher
